// 用户相关
export const USER_SIGNIN = 'USER_SIGNIN';
export const USER_SIGNOUT = 'USER_SIGNOUT';
export const LOGIN_FORM_SHOW = 'LOGIN_FORM_SHOW';
export const LOGIN_FORM_HIDE = 'LOGIN_FORM_HIDE';
export const LOGIN_LOCAL = 'LOGIN_LOCAL';
export const SET_LOGININFO = 'SET_LOGININFO';
export const LOGOUT = 'LOGOUT';
export const HIDE_LOGIN_FORM = 'HIDE_LOGIN_FORM';
export const SHOW_LOGIN_FORM = 'SHOW_LOGIN_FORM';
export const CHECK_LOGIN_FORM = 'CHECK_LOGIN_FORM';
export const UPDATE_FOLLOWS = 'UPDATE_FOLLOWS';
export const GET_FOLLOWS = 'GET_FOLLOWS';
export const FOLLOW = 'FOLLOW';
export const UNFOLLOW = 'UNFOLLOW';
export const UPDATE_FOCUS = 'UPDATE_FOCUS';
export const GET_FOCUS = 'GET_FOCUS';
export const FOCUS = 'FOCUS';
export const UNFOCUS = 'UNFOCUS';
export const INIT_ADVERTISEMENT = 'INIT_ADVERTISEMENT';
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';
export const STOCKFOCUS = 'STOCKFOCUS';
export const UNSTOCKFOCUS = 'UNSTOCKFOCUS';
export const GET_STOCK_FOCUS = 'GET_STOCK_FOCUS';
export const UPDATE_STOCK_FOCUS = 'UPDATE_STOCK_FOCUS';
// 获取用户info和关注数，粉丝数，发表数，股票数  --wym
export const GET_USER_COUNT = 'GET_USER_COUNT';
// 更新自选股数量
export const UPDATE_STOCK_COUNT = 'UPDATE_STOCK_COUNT';
// 更新关注数
export const UPDATE_FOLLOWING_COUNT = 'UPDATE_FOLLOWING_COUNT';
// 获取发表总数
export const UPDATE_PUBLISH_COUNT = 'UPDATE_PUBLISH_COUNT';
// 获取粉丝总数
export const USER_ISLOGIN = 'USER_ISLOGIN';

export const SERVER_ISLOGIN = 'SERVER_ISLOGIN';
export const SET_VIP_MEMBER_INFO = 'SET_VIP_MEMBER_INFO';
export const SET_USER_INFO_KYC = 'SET_USER_INFO_KYC';

// 支付订单弹窗相关
export const SET_ORDER_SHOW = 'SET_ORDER_SHOW';
export const SET_ORDER_DATA = 'SET_ORDER_DATA';
export const SET_ORDER_SPECSID = 'SET_ORDER_SPECSID';
export const SET_ORDER_INFO = 'SET_ORDER_INFO';
export const SET_USER_COIN = 'SET_USER_COIN';

// 是否显示svip
export const SHOW_SVIP = 'SHOW_SVIP';
